import "./account.scss";

import type { ReactNode } from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import { marketingHost } from "constants/marketing";
import { NOTARY_CORPORATE_ENTRYPOINT } from "constants/notary";
import TitleImg from "assets/images/title-agent-house.svg";
import NotaryImg from "assets/images/notary-stamp.svg";

type Props = {
  children: ReactNode;
  showFooter?: boolean;
  subheader?: ReactNode;
  className?: string;
};

const LINK_CX = "AccountContainer--footer--alternatives--link";

function AccountContainer({ showFooter, subheader, children, className }: Props) {
  const navigate = useNavigate();
  return (
    <div className={classnames("AccountContainer", className)}>
      <div className="AccountContainer--header">
        <a className="AccountContainer--header--link" href={marketingHost}>
          <FormattedMessage id="1fe3828e-0078-43ed-9f71-ccf2da2bda36" defaultMessage="Notarize" />
        </a>
      </div>
      <div className="AccountContainer--container" data-automation-id="account-container">
        <div className="AccountContainer--container--top">
          <h2 className="AccountContainer--subheader">{subheader}</h2>
        </div>
        <div className="AccountContainer--container--panels">{children}</div>
        {showFooter && (
          <div className="AccountContainer--footer">
            <div className="AccountContainer--footer--divider">
              <div className="AccountContainer--footer--divider--line" />
              <FormattedMessage id="e4198b59-12eb-4062-8b63-48e70a3c169a" defaultMessage="OR" />
              <div className="AccountContainer--footer--divider--line" />
            </div>
            <div className="AccountContainer--footer--alternatives">
              <a
                className={LINK_CX}
                href={NOTARY_CORPORATE_ENTRYPOINT}
                target="_blank"
                rel="noreferrer noopener"
              >
                <img src={NotaryImg} alt="" aria-hidden="true" />
                <FormattedMessage
                  id="5fd95fe7-a29d-4c3a-965e-51e0035a4b8a"
                  defaultMessage="I'm a notary"
                />
              </a>
              <div
                role="button"
                tabIndex={0}
                className={LINK_CX}
                onClick={() => {
                  navigate("/signup/title-agency");
                }}
              >
                <img src={TitleImg} alt="" aria-hidden="true" />
                <FormattedMessage
                  id="4e6b9a0d-372b-4c88-b371-dd3cf6d46681"
                  defaultMessage="I'm a title agent"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default AccountContainer;
